import * as React from "react";
import TextField from "@mui/material/TextField";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
//jalalai and persian calendar ,for kabise year, use persian calendar=========
import calendar from "react-date-object/calendars/jalali";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import { useEffect, useState } from "react";
import CustomisedTextField from "../textField/textField";
import { IDatePicker } from "./IDatePicker";
const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
});

interface DatePickerCmpPropsInterface {
    onChange: Function;
    value?: Date | null;
    error?: boolean;
    helperText?: string;
    label?: string;
    range: boolean;
    valueArray?: Date[] | null;
    fixMainPosition?: boolean;
}

export default function DatePickerComponents({
    onChange,
    value,
    error,
    helperText,
    label,
    disabled,
    placeHolder,
}: IDatePicker) {
    function handleOnChange(newValue: any) {
        onChange(newValue);
    }
    let dateYear = new Date(value!)
        .toLocaleDateString("fa-IR-u-ca-persian")
        .split("/")[0];

    return (
        <>
            <div
                style={{
                    direction: 'rtl',
                    margin: 'auto',
                    textAlign: 'center',
                    height: '50px',
                    alignItems: 'center',
                    position: "relative"
                }}
                className="yekanBakhFaNum"
            >
                <DatePicker
                    render={<CustomComponent label={label} error={error} />}
                    inputClass="form-control"
                    value={value}
                    format={"YYYY/MM/DD"}
                    className="datePicker"
                    calendar={dateYear === "۱۴۰۴" ? persian : calendar}
                    onYearChange={(date: any) => {
                        handleOnChange(date);
                    }}
                    onChange={(newValue: any) => {
                        handleOnChange(newValue as Date);
                    }}
                    locale={persian_fa}
                    calendarPosition="bottom-center"
                    containerStyle={{ width: "100%" }}
                    plugins={[<Toolbar position="bottom" />]
                    }
                    range={false}
                    dateSeparator=" - "
                    fixMainPosition={true}
                />
            </div>
        </>
    );
}

const CustomComponent = (props: any) => {
    // const [jsonFile, setJsonFile] = useState<any>();
    // useEffect(() => {
    //     fetch(`${process.env.REACT_APP_SHELL_CONFIG}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             setJsonFile(data);
    //         });
    // }, []);
    return (
        <CacheProvider value={cacheRtl}>
            <FormControl fullWidth>
                <CustomisedTextField
                    value={props.value}
                    onclick={props.openCalendar}
                    label={props.label}
                    error={props.error}
                    id="custom-css-outlined-input"
                    autoComplete="off"
                    onFocus={(e: any) => e.target.blur()}
                />
            </FormControl>
        </CacheProvider>
    );
};
